var $ = require('jquery');

$(document).ready(function() {
    initParagraph();
})
function initParagraph() {
    $('.page-section--main p').each(function() {
        var next = $(this).next();

        if(next.length != 0) {
            var tag = next.prop('tagName');

            if(tag == 'UL' || tag == 'OL') {
                $(this).addClass('-margin');
                next.addClass('-margin');
            }
        }
    })
}
